// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
// Plutonium's own JS was never wired in — its `Turbo.StreamActions.redirect`
// (what every interactive-action success response uses to navigate away,
// see interactive_actions.rb#redirect_url_after_action_on) and its built-in
// Stimulus controllers (form, nested-resource-form-fields, slim-select, …)
// were silently missing from every build. Surfaced by the POS "Start your
// shift" modal never dismissing after submit — a plain HTML form success
// relies on exactly this custom action to navigate off the modal.
import { registerControllers } from "@radioactive-labs/plutonium"
import { application } from "./controllers/application"
import "./controllers"

registerControllers(application)
